import 'css-chunk:src/app/containers/Home/ClientFeaturesView/EditFeatureDrawer.scss';export default {
  "EditFeatureDrawer": "_EditFeatureDrawer_ru9n4_1",
  "form": "_form_ru9n4_1",
  "submitButton": "_submitButton_ru9n4_1"
};